const isPrivateLanHostname = (hostname: string): boolean => {
  const match = /^192\.168\.(\d{1,3})\.(\d{1,3})$/.exec(hostname);
  if (!match) return false;

  return Number(match[1]) <= 255 && Number(match[2]) <= 255;
};

export const isNonProductionHostname = (hostname: string): boolean => {
  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname === '[::1]' ||
    isPrivateLanHostname(hostname) ||
    hostname === 'adu-lab-uat.web.app' ||
    /^adu-lab-uat--[a-z0-9-]+\.web\.app$/i.test(hostname) ||
    /^[a-z0-9-]+\.trycloudflare\.com$/i.test(hostname);
};

export const isNonProductionEnvironment = (): boolean => {
  return isNonProductionHostname(window.location.hostname);
};
